module.exports = __webpack_public_path__ + "static/HF_TWSSC-2947abdf17ceece338ced6c4f09cbf19.png";